<script>
  import { createEventDispatcher } from "svelte";
  const dispatch = createEventDispatcher();

  export let title = "Alerta";
  export let message = "";
  export let button1Label = "Ok";
  export let button2Label = "";
  export let button3Label = "";

  export let button1Action = () => closeDialog();
  export let button2Action = () => closeDialog();
  export let button3Action = () => closeDialog();
  export let entradaTexto;
  export let temInput = false;
  function handleButtonClick(action) {
    action();
  }

  function closeDialog() {
    dispatch("close");
    message = "";
  }
</script>

{#if message !== ""}
  <div class="modal">
    <div class="modal-content">
      <div class="modal-header">
        <h2>{title}</h2>
        <button class="close-button" on:click={closeDialog}>&times;</button>
      </div>
      <div class="modal-body">
        <p>{@html message}</p>
        {#if temInput}
          <input type="text" bind:value={entradaTexto} />
        {/if}
      </div>
      <div class="modal-footer">
        {#if button1Label}
          <button
            class="modal-button"
            on:click={() => handleButtonClick(button1Action)}
            >{button1Label}</button
          >
        {/if}
        {#if button2Label}
          <button
            class="modal-button"
            on:click={() => handleButtonClick(button2Action)}
            >{button2Label}</button
          >
        {/if}
        {#if button3Label}
          <button
            class="modal-button"
            on:click={() => handleButtonClick(button3Action)}
            >{button3Label}</button
          >
        {/if}
      </div>
    </div>
  </div>
{/if}

<style>
  @import url("https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700&display=swap");

  .modal {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 2000;
  }

  .modal-content {
    font-family: "Inter", sans-serif;
    background-color: #fff;
    padding: 20px;
    border-radius: 12px;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2);
    width: 90%;
    max-width: 500px;
    position: relative;
    animation: fadeIn 0.3s;
  }

  .modal-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #eaeaea;
    padding-bottom: 10px;
  }

  .modal-header h2 {
    margin: 0;
    font-size: 1.5rem;
  }

  .close-button {
    background: none;
    border: none;
    font-size: 1.5rem;
    cursor: pointer;
  }

  .modal-body {
    margin-top: 10px;
    font-size: 1rem;
    color: #333;
  }

  .modal-footer {
    display: flex;
    justify-content: center;
    margin-top: 20px;
    flex-wrap: wrap;
  }

  .modal-button {
    margin-left: 10px;
    margin-top: 0;
    padding: 10px 20px;
    border: none;
    border-radius: 4px;
    cursor: pointer;
    background-color: #007bff;
    color: #fff;
    font-size: 1rem;
    flex: 0 0 auto; /* Define o tamanho inicial dos botões */
    max-width: 150px; /* Define a largura máxima dos botões */
    word-break: normal; /* Evita que as palavras sejam quebradas */
  }
  .modal-button:hover {
    background-color: #0056b3;
  }

  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: scale(0.9);
    }
    to {
      opacity: 1;
      transform: scale(1);
    }
  }
</style>
